import React from 'react';
import { Navigate } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';

import DashboardLayout from '~/components/layouts/DashboardLayout';
import NotFoundView from '~/views/public/errors/NotFoundView';
import ContactsView from '~/views/private/contacts/ContactsView';
import GalleryView from '~/views/private/gallery/GalleryView';
import BillingsView from '~/views/private/billings/BillingsView';
import OverviewView from '~/views/private/overview/OverviewView';
import LocationOverviewView from '~/views/private/overview/LocationOverviewView';
import MultilocationOverviewView from '~/views/private/overview/MultilocationOverviewView';
import Explorer3DOverviewView from '~/views/private/overview/Explorer3DOverviewView';

const routes = () => [
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { path: '', element: <Navigate to="/overview" replace /> },
      // { path: 'login', element: <ClerkAuth /> }, // custom login form
      { path: 'billings', element: <BillingsView /> },
      { path: 'gallery', element: <GalleryView /> },
      { path: 'contacts', element: <ContactsView /> },
    ],
  },
  {
    path: 'login/*',
    element: (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          width: '100%',
        }}
      >
        <SignIn
          routing="hash"
          path={null}
          appearance={{
            variables: { colorPrimary: '#5e59f3' },
            elements: {
              footer: { display: 'none' },
            },
          }}
        />
      </div>
    ),
  },
  {
    path: 'overview',
    element: <DashboardLayout />,
    children: [
      { path: '', element: <OverviewView /> },
      { path: 'location/:locationId', element: <LocationOverviewView /> },
      {
        path: 'multi/:companyName/:listId',
        element: <MultilocationOverviewView />,
      },
      {
        path: 'multi/3dExplorer/:companyName/:listId/:explorer3DName',
        element: <Explorer3DOverviewView />,
      },
    ],
  },
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      { path: '404', element: <NotFoundView /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
];

export default routes;
